import { EditOutlined } from '@ant-design/icons';
import React, { FC, useEffect, useState } from 'react';
import Wrap from './styles';

type Props = {
  currentStep: number;
  nextStep: () => void;
};
const HeaderRegister: FC<Props> = ({ nextStep, currentStep }) => {
  const [title, setTitle] = useState<string>('1. 医療機関入力');
  const [current, setCurrent] = useState<number>(0);

  useEffect(() => {
    setCurrent(currentStep);
    switch (currentStep) {
      case 0:
        setTitle('1. 医療機関入力');
        break;
      case 1:
        setTitle('2. 登録内容の確認');
        break;
      case 2:
        setTitle('3. 登録完了');
        break;
    }
  }, [currentStep]);

  return (
    <Wrap>
      <div className="header1">
        <div>
          <EditOutlined className="icon1" />
          <p className="extraLargeFont inline">新規医療機関登録</p>
        </div>
        <div className="wrap-steps">
          <div className={`step-item ${current === 0 && 'step-active'}`}>
            <div className="step-icon">
              <span>1</span>
            </div>
            <span>医療機関情報入力</span>
            <span className="step-arrow"></span>
          </div>
          <div className={`step-item ${current === 1 && 'step-active'}`}>
            <span className="step-icon">2</span>
            <span>登録内容の確認</span>
            <span className="step-arrow"></span>
          </div>
          <div className={`step-item ${current === 2 && 'step-active'}`}>
            <span className="step-icon">3</span>
            <span>登録完了</span>
          </div>
        </div>
      </div>
      <div className="header2 extraLargeFont">{title}</div>
    </Wrap>
  );
};

export default HeaderRegister;
